export default () => {
	for (const el of document.querySelectorAll("[data-accordion]")) {
		const showText = el.getAttribute("data-show-text");
		const hideText = el.getAttribute("data-hide-text");

		for (const trigger of el.querySelectorAll("[aria-controls]")) {
			trigger.addEventListener("click", () => {
				console.log("blah");
				const target = document.getElementById(
					trigger.getAttribute("aria-controls"),
				);

				if (target !== null) {
					const expanded =
						trigger.getAttribute("aria-expanded") === "true" ? "false" : "true";

					target.classList.toggle("hidden");
					target.setAttribute(
						"aria-hidden",
						expanded === "true" ? "false" : "true",
					);
					trigger.setAttribute("aria-expanded", expanded);

					if (hideText !== null && showText !== null) {
						trigger.innerHTML = expanded === "true" ? hideText : showText;
					}
				}
			});
		}
	}
};
